import { Autocomplete, Box, TextField, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

const ExpenseTab = ({
    description,
    setDescription,
    amount,
    setAmount,
    selectedExpenseAccount,
    setSelectedExpenseAccount,
    expenseAccounts,
}) => {
    const { t } = useTranslation();
    return (
        <>
            <TextField
                label={t("cashOut.description")}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                fullWidth
                margin="normal"
                variant="standard"
                required
            />
            <TextField
                label={t("cashOut.amount")}
                type="number"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                fullWidth
                margin="normal"
                variant="standard"
                inputProps={{ min: 0, step: 0.01 }}
                required
            />
            <Autocomplete
                options={expenseAccounts || []}
                getOptionLabel={(option) => option.account_name || option.name}
                value={
                    expenseAccounts?.find(
                        (acc) => acc.name === selectedExpenseAccount
                    ) || null
                }
                onChange={(event, newValue) => {
                    setSelectedExpenseAccount(newValue?.name || "");
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={t("cashOut.expenseAccount")}
                        variant="standard"
                        margin="normal"
                        required
                        fullWidth
                    />
                )}
                renderOption={(props, option) => (
                    <Box component="li" {...props}>
                        <Typography variant="body2">
                            {option.account_name || option.name}
                        </Typography>
                    </Box>
                )}
            />
        </>
    );
};

export default ExpenseTab;
